// @flow

import React, { type Element } from 'react'
import { TextField, Box } from '@material-ui/core'
import type { ServiceLocation } from '../../types'

type Props = {|
  serviceLocation: ServiceLocation,
  setServiceLocation: (ServiceLocation) => void,
  serviceLocationList: Array<ServiceLocation>,
  error: string,
|}

const NONE_VALUE = '0'

function DefaultServiceLocationSelect({
  serviceLocation,
  setServiceLocation,
  serviceLocationList,
  error,
}: Props): Element<typeof React.Fragment> {
  const handleServiceLocationChange = (event: SyntheticInputEvent<HTMLInputElement>): void => {
    let value = event.target.value
    if (event.target.value === NONE_VALUE) value = null
    const newServiceLocation: ServiceLocation | void = serviceLocationList.find(
      (serviceLocation) => {
        return serviceLocation.code === value
      }
    )
    if (newServiceLocation) setServiceLocation(newServiceLocation)
  }

  return (
    <Box py={2}>
      <TextField
        id="default-service-location-select"
        select
        label="Default Service Location"
        variant="outlined"
        fullWidth
        error={error !== ''}
        helperText={error ? 'Service Location ' + error : error}
        value={serviceLocation?.code || NONE_VALUE}
        onChange={handleServiceLocationChange}
        SelectProps={{
          native: true,
        }}
      >
        {serviceLocationList.map((location) => (
          <option key={location.code || NONE_VALUE} value={location.code || NONE_VALUE}>
            {location.name}
          </option>
        ))}
      </TextField>
    </Box>
  )
}

export default DefaultServiceLocationSelect
